import React from "react";
import { Formik, Form, Field } from "formik";
import { ApiService } from "../../../../../services/ApiService";

export default function AddcaseModal({ closeModal, employee_cases, alert }) {
  return (
    <React.Fragment>
      <Formik
        initialValues={{ disciplinary_case: "" }}
        onSubmit={(values) => {
          ApiService.post("disciplinary-cases/create-case", values).then((res) => {
            closeModal();
            if (res.data.type === false) {
              alert.error(res.data.msg);
            } else if (res.data.type === true) {
              alert.success(res.data.msg);
              employee_cases();
            }
          });
        }}
      >
        {({ handleSubmit, values, isSubmitting }) => (
          <Form>
            <div class="form-group">
              <label for="exampleInputtext">
                New Case <span className="text-danger">*</span>
              </label>
              <Field
                type="text"
                className="form-control"
                name="disciplinary_case"
                value={values.disciplinary_case}
                required
              />{" "}
            </div>
            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Save{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/employeemanagement/disciplinarycase/modals/add_case.js